angular.module('eStories.see-all-link.compnt', [])

    .component('seeAllLink', {
        transclude: true,
        bindings: {
            section: '<',
            white: '<',
            narrator: '<',
            author: '<'
        },
        templateUrl: 'components/see-all-link/see-all-link.tmpl.html'
    });
